<template>
    <div class="patient-info-management">
        <div class="patient-info-card">
            <!-- <div class="info-header">
                <button class="nav-btn"><img src="@/assets/resource/icon/arrow-left_thin.png" alt="뒤로가기" @click="goBack" /></button>
                <button class="toggle-btn" @click="isCollapsed = !isCollapsed">{{ isCollapsed ? "정보 펼치기" : "정보 접기" }}</button>
            </div> -->
            <div v-show="!isCollapsed" class="patient-info-grid">
                <div class="info-item">
                    <span class="label">환자번호</span>
                    <span class="value">{{patientId}}</span>
                </div>
                <div class="info-item">
                    <span class="label">환자명</span>
                    <span class="value">{{name}}</span>
                </div>
                <div class="info-item">
                    <span class="label">생년월일</span>
                    <span class="value">{{birth}}</span>
                </div>
                <div class="info-item">
                    <span class="label">연령</span>
                    <span class="value">{{age}}</span>
                </div>
                <template v-if="showPainArea">
                    <div class="info-item">
                        <span class="label">몸무게(kg)</span>
                        <span class="value">{{convertUtils.convertWeight(weight)}}</span>
                    </div>
                    <!-- <div class="info-item">
                        <span v-if="chageName"  class="label">검사일</span>
                        <span v-else  class="label">최근 검사일</span>
                        <span class="value">{{lastExam}}</span>
                    </div> -->
                </template>
                <div class="info-item" v-else>
                    <span class="label">몸무게(kg)</span>
                    <span class="value">{{convertUtils.convertWeight(weight)}}</span>
                </div>
            </div>
            <!-- <div class="pain-area" v-if="!isCollapsed && showPainArea">
                <span class="label">통증 부위</span>:&nbsp;
                <span class="value">{{painArea}}</span>
            </div> -->
            <!-- <button
                class="toggle-btn toggle-btn-bottom"
                :class="{ collapsed: isCollapsed }"
                @click="isCollapsed = !isCollapsed"
                aria-label="환자정보 접기/펼치기"
            >
                <span class="chevron">
                    <img class="chevron_icon" src="@/assets/resource/icon/arrow-down_thin.png" alt="arrow-up" />
                </span>
            </button> -->
        </div>
    </div>
</template>
<script setup>
    import { ref }          from "vue";
    import { useRouter }    from "vue-router";
    import { commonUtils }  from "@/utils/commonUtils";
    import { convertUtils } from "@/utils/convertUtils";

    const router = useRouter()

    // 접기 상태
    const isCollapsed = ref(false);

    defineProps({
        patientId : String,
        name      : String,
        birth     : String,
        age       : String,
        weight    : [String, Number],
        lastExam  : String,
        painArea  : String,
        showPainArea: { // ✅ 새로운 prop
            type: Boolean,
            default: true
        },
        chageName: {
            type: Boolean,
            default: false
        }
    })

    function goBack() {
        router.back()
    }
</script>
